export const size0 = '0';
export const size1 = '0.0625rem';
export const size2 = '0.125rem';
export const size4 = '0.25rem';
export const size8 = '0.5rem';
export const size10 = '0.6rem';
export const size12 = '0.75rem';
export const size14 = '0.875rem';
export const size16 = '1rem';
export const size18 = '1.125rem';
export const size20 = '1.25rem';
export const size24 = '1.5rem';
export const size30 = '1.875rem';
export const size32 = '2rem';
export const size36 = '2.25rem';
export const size40 = '2.5rem';
export const size48 = '3rem';
export const size64 = '4rem';
export const size80 = '5rem';
export const size96 = '6rem';
export const size144 = '9rem';
export const CONTROL_SIZE_MAP = {
  sm: {
    'font-size': size14,
    padding: `0 ${size12}`,
    height: size30
  },
  md: {
    'font-size': size14,
    padding: `0 ${size14}`,
    height: size36
  },
  lg: {
    'font-size': size16,
    padding: `0 ${size16}`,
    height: size48
  }
};
//# sourceMappingURL=scale.js.map